import { render, staticRenderFns } from "./martial-view.vue?vue&type=template&id=5b09e749&scoped=true&"
import script from "./martial-view.vue?vue&type=script&lang=js&"
export * from "./martial-view.vue?vue&type=script&lang=js&"
import style0 from "./martial-view.vue?vue&type=style&index=0&id=5b09e749&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09e749",
  null
  
)

export default component.exports